import React from 'react';
import classNames from 'classnames';

import styles from './list-item.less';

var defaultRoute = '#';

module.exports = React.createClass({
  displayName: 'ListItem',
  getDefaultProps() {
    return {
      disabled: false,
      unvisible: false,
      active: false,
      url: defaultRoute
    }
  },
  propTypes: {
    active: React.PropTypes.bool,
    value: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number
    ]).isRequired,
    unvisible: React.PropTypes.bool,
    disabled: React.PropTypes.bool,
    url: React.PropTypes.string,
    onClick: React.PropTypes.func.isRequired
  },
  handleClick() {
    this.props.onClick(this.props.value);
  },
  handleLinkClick(e) {
    if (this.props.url == defaultRoute) {
      e.preventDefault();
    }
  },
  getClass() {
    return classNames(styles.listItem, {
      active: this.props.active,
      disabled: this.props.disabled
    });
  },
  render() {
    return this.props.unvisible ? null : <li className={this.getClass()} onClick={this.handleClick}>
      <a ref="link" href={this.props.url} onClick={this.handleLinkClick} className={styles.link}>{this.props.children}</a>
    </li>;
  }
});



/** WEBPACK FOOTER **
 ** ./src/lists/list-item/index.js
 **/